<div class="inner-page-header inner-page-header--department">
  <h1>{{ "all-services.umang-services" | translate }}</h1>
  <p class="page-sub-title">{{'all-services.page-title' | translate}}</p>
</div>

<div class="container">
  <!-- Department search & state filter section -->
  <app-service-state-filter
    [filterConfig]="filterConfig"
    [list]="serviceStateList"
    [allService]="filteredServices"
    [states]="states"
    (applyFilter)="onFilterServices()"
  ></app-service-state-filter>

  <!-- Categories filter section -->
  <app-category-chips
    [categories]="categories"
    [filterConfig]="filterConfig"
    (applyCategory)="onEditCategory($event)"
  ></app-category-chips>

  <!-- Service cards section -->
  <app-service-list
    [filteredServices]="filteredServices"
    [isLoading]="isServicesLoading"
  ></app-service-list>
</div>
